import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { setUserObject, resetUserObject } from './user.actions';

@Injectable()
export class UserEffects {
  private actions$ = inject(Actions);

  // Sync legacy 'userData' key to localStorage as a side-effect
  saveUserData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setUserObject),
        tap((action) => {
          if (typeof window !== 'undefined' && window.localStorage) {
            // Remove 'type' property from action payload before saving to match legacy behavior
            const { type, ...userData } = action as any;
            localStorage.setItem('userData', JSON.stringify(userData));
          }
        })
      ),
    { dispatch: false }
  );

  clearUserData$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(resetUserObject),
        tap(() => {
          if (typeof window !== 'undefined' && window.localStorage) {
            localStorage.removeItem('userData');
          }
        })
      ),
    { dispatch: false }
  );
}
